module.exports = __webpack_public_path__ + "static/media/Cliente.97510fcc.apk";